(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paaro-couture-product"] && !Shopify.designMode) return;
  try {
    
/* pp-eta:start
   Standard Shipping estimate. Reads the durations already written in the Shipping information
   block (e.g. "7-12 business days", "up to 7-8 weeks", "upto 12 weeks") and turns each one into
   dates counted from today. Nothing is hardcoded: the label, numbers, unit and "up to" wording
   all come from that text, so editing the Shipping information updates the estimate. */
const PaaroShippingEta={
  duration:/\b(?:(up\s*to|upto|within|in)\s*)?(\d{1,3})\s*(?:(?:-|–|—|to)\s*(\d{1,3}))?\s*(business|working)?\s*(day|week|month)s?\b/gi,
  verb:/\s+(?:will|may|might|can|could|should|would|shall|must|usually|typically|generally|normally|take|takes|are|is)\b/i,
  sentences(texts){
    return texts.flatMap(t=>t.split(/\n+/)).flatMap(line=>line.replace(/\s+/g,' ').replace(/([.!?])(?:\s+|(?=[A-Z]))/g,'$1\n').split('\n')).map(s=>s.trim()).filter(Boolean);
  },
  parse(sentences){
    const rules=[];
    sentences.forEach(sentence=>{
      for(const m of sentence.matchAll(this.duration)){
        const [whole,qualifier,a,b,business,unit]=m;
        let min=Number(a),max=Number(b||a);
        if(min>max)[min,max]=[max,min];
        if(!max)continue;
        const head=sentence.slice(0,m.index);
        const cut=head.search(this.verb);
        let label=cut>0?head.slice(0,cut).replace(/[\s,:;–—-]+$/,'').trim():'';
        if(label.length>60)label='';
        const keepQualifier=qualifier&&!/^in$/i.test(qualifier);
        let phrase=keepQualifier?whole.trim():whole.slice(qualifier?qualifier.length:0).trim();
        let span=unit.toLowerCase();
        // Weeks and months are converted to days first (1 week = 7 days, 1 month = 30 days), so every
        // Standard Shipping line is counted and shown in days. Business/working days stay as written.
        const toDays={week:7,month:30}[span];
        if(toDays){
          min*=toDays;max*=toDays;span='day';
          const qualifierText=keepQualifier?(/^up/i.test(qualifier)?'up to ':qualifier.toLowerCase()+' '):'';
          phrase=`${qualifierText}${min===max?min:`${min}–${max}`} ${max===1?'day':'days'}`;
        }
        rules.push({label,phrase,min,max,unit:span,business:Boolean(business),upTo:Boolean(qualifier&&/^up/i.test(qualifier)&&!b)});
      }
    });
    return rules;
  },
  add(base,amount,unit,business){
    const d=new Date(base.getFullYear(),base.getMonth(),base.getDate());
    if(unit==='day'&&business){let left=amount;while(left>0){d.setDate(d.getDate()+1);const w=d.getDay();if(w!==0&&w!==6)left-=1;}return d;}
    if(unit==='day'){d.setDate(d.getDate()+amount);return d;}
    if(unit==='week'){d.setDate(d.getDate()+amount*7);return d;}
    const day=d.getDate();d.setDate(1);d.setMonth(d.getMonth()+amount);
    d.setDate(Math.min(day,new Date(d.getFullYear(),d.getMonth()+1,0).getDate()));
    return d;
  },
  format(date,today,locale){
    const options={weekday:'short',day:'numeric',month:'short'};
    if(date.getFullYear()!==today.getFullYear())options.year='numeric';
    try{return new Intl.DateTimeFormat(locale||undefined,options).format(date);}catch(error){return date.toDateString();}
  },
  estimate(rules,today,locale){
    const seen=new Set();
    return rules.map(rule=>{
      const end=this.format(this.add(today,rule.max,rule.unit,rule.business),today,locale);
      const start=this.format(this.add(today,rule.min,rule.unit,rule.business),today,locale);
      const dates=rule.upTo?`By ${end}`:rule.min===rule.max?end:`${start} – ${end}`;
      return {label:rule.label,phrase:rule.phrase,dates};
    }).filter(row=>{const key=row.label+'|'+row.dates;if(seen.has(key))return false;seen.add(key);return true;});
  }
};
/* pp-eta:end */
if (!customElements.get('paaro-product')) customElements.define('paaro-product', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.hydrateDescription();
    this.renderShippingEstimate();
    this.initWishlist();
    this.mountWishlistFade();
    this.routeSizeChart();
    this.addEventListener('click', e => this.clickHandler(e), {signal:this.abort.signal});
    this.addEventListener('change', e => {if(e.target.matches('[data-option]')){this.renderShippingEstimate();this.changeVariant(e.target);}}, {signal:this.abort.signal});
    // Records the last pointer type and whether a touch became a pan, so a click at the end of a drag is ignored.
    this.addEventListener('pointerdown', e => {this.panned=false;this.lastPointerType=e.pointerType;}, {signal:this.abort.signal});
    // Hover-capable pointers (mouse, trackpad) below the desktop breakpoint: zoom on enter, reset on leave.
    this.addEventListener('pointerover', e => this.hoverZoomIn(e), {signal:this.abort.signal});
    this.addEventListener('pointerout', e => this.hoverZoomOut(e), {signal:this.abort.signal});
    this.addEventListener('pointermove', e => {
      const button=e.target.closest('[data-zoom]');
      if(!button) return;
      if(button.classList.contains('is-zoomed')){
        if(e.pointerType==='touch'&&e.buttons)this.panned=true;
        this.setInlineZoomOrigin(button,e);
        return;
      }
      const panel=this.querySelector('.pp-zoom-panel');
      if(panel.hidden) return;
      const box=button.getBoundingClientRect();
      panel.style.backgroundPosition=`${Math.max(0,Math.min(100,(e.clientX-box.left)/box.width*100))}% ${Math.max(0,Math.min(100,(e.clientY-box.top)/box.height*100))}%`;
    }, {signal:this.abort.signal});
    this.addEventListener('keydown', e=>{if(e.key==='Escape'){this.querySelector('.pp-zoom-panel').hidden=true;this.querySelectorAll('.pp-image-button.is-zoomed').forEach(b=>b.classList.remove('is-zoomed'));}}, {signal:this.abort.signal});
  }
  hydrateDescription(){
    const source=this.querySelector('[data-description-source]');
    const description=this.querySelector('[data-description-target]');
    const shipping=this.querySelector('[data-shipping-target]');
    if(!source)return;
    const normalize=value=>value.trim().toLowerCase();
    const descriptionHeading=normalize(this.dataset.descriptionHeading||'Product Description');
    const shippingHeading=normalize(this.dataset.shippingHeading||'Shipping Information');
    const buckets={description:[],shipping:[]};
    let bucket='description';
    [...source.children].forEach(node=>{
      if(node.tagName==='H3'){
        const heading=normalize(node.textContent);
        if(heading===descriptionHeading){bucket='description';return;}
        if(heading===shippingHeading){bucket='shipping';return;}
      }
      buckets[bucket].push(node.outerHTML);
    });
    if(description)description.innerHTML=buckets.description.join('')||source.innerHTML;
    // The vendor collection's description wins; the product description's Shipping H3 is only used when there is none.
    if(shipping&&buckets.shipping.length&&shipping.dataset.shippingSource!=='collection')shipping.innerHTML=buckets.shipping.join('');
  }
  renderShippingEstimate(){
    // Shown under the size selector only while a size is selected and the selected variant can be
    // ordered. Durations come from the Shipping information block as rendered above (after
    // hydrateDescription), so it always matches what that section says.
    const box=this.querySelector('[data-shipping-eta]');
    if(!box)return;
    const list=box.querySelector('[data-shipping-eta-list]');
    const reset=()=>{box.hidden=true;list.replaceChildren();};
    const sizeSelected=Boolean(this.querySelector('[data-size-fieldset] [data-option]:checked'));
    const source=this.querySelector('[data-shipping-target]');
    if(!sizeSelected||!source||this.dataset.available==='false')return reset();
    // Collection descriptions may use <p>, <div>, lists or <br> line breaks; each becomes its own line before parsing.
    const html=source.innerHTML.replace(/<br\s*\/?>|<\/(?:p|div|li|h[1-6]|tr|td|th|blockquote)>/gi,'$&\n');
    const text=new DOMParser().parseFromString(html,'text/html').body.textContent||'';
    const rows=PaaroShippingEta.estimate(PaaroShippingEta.parse(PaaroShippingEta.sentences([text])),new Date());
    if(!rows.length)return reset();
    list.replaceChildren(...rows.map(row=>{
      const item=document.createElement('li');item.className='pp-ship-eta__row';
      const text=document.createElement('span');
      const label=document.createElement('span');label.className='pp-ship-eta__label';label.textContent=row.label||'Estimated delivery';
      const phrase=document.createElement('small');phrase.className='pp-ship-eta__phrase';phrase.textContent=row.phrase;
      const dates=document.createElement('strong');dates.className='pp-ship-eta__date';dates.textContent=row.dates;
      text.append(label,phrase);item.append(text,dates);return item;
    }));
    box.hidden=false;
  }
  initWishlist(){
    const custom=this.querySelector('.wishlist-hero-custom-button');
    const target=this.querySelector('#wishlist-hero-product-page-button');
    if(!custom)return;
    let tries=0;
    this.wishlistTimer=setInterval(()=>{
      tries+=1;
      if(target?.children.length){clearInterval(this.wishlistTimer);return;}
      const sdk=window.WishListHero_SDK;
      if(sdk?.InitializeAddToWishListButton){
        sdk.InitializeAddToWishListButton({ButtonClassElement:[...custom.classList].find(name=>name.startsWith('wishlisthero-floating-')),ProductId:custom.dataset.wlhId,ProductLink:custom.dataset.wlhLink,ProductVariantId:custom.dataset.wlhVariantid,ProductPrice:Number(custom.dataset.wlhPrice),ProductTitle:custom.dataset.wlhName,ProductImage:custom.dataset.wlhImage,ButtonMode:'icon_only',WishlistHash:'Product'});
        clearInterval(this.wishlistTimer);
      }else if(tries>=20)clearInterval(this.wishlistTimer);
    },250);
  }
  mountWishlistFade(){
    // Fallback only: Liquid normally renders the Wishlist Fade block in the slot already
    // (even before the app's script has drawn its button), in which case nothing is moved.
    // Moves (never clones) the app's own block node, so the app's handlers stay attached.
    const slot=this.querySelector('[data-gallery-wishlist]');
    if(!slot||slot.querySelector('.pp-gallery-wishlist__app,.wl-btn'))return;
    const find=()=>{
      const blocks=[...this.querySelectorAll('.pp-info .pp-app-block')];
      return blocks.find(b=>b.querySelector('.wl-btn'))||blocks.find(b=>/wishlist/i.test(b.innerHTML));
    };
    const tryMove=()=>{const block=find();if(!block)return false;slot.querySelector('[data-wishlist-proxy]')?.remove();slot.appendChild(block);return true;};
    if(tryMove())return;
    this.wishlistObserver=new MutationObserver(()=>{if(tryMove())this.wishlistObserver.disconnect();});
    this.wishlistObserver.observe(this.querySelector('.pp-info'),{childList:true,subtree:true});
    setTimeout(()=>this.wishlistObserver?.disconnect(),8000);
    this.linkWishlistProxy(slot);
  }
  linkWishlistProxy(slot){
    // The corner heart when Wishlist Fade's block isn't in this section. It never saves anything
    // itself: a click is forwarded to the app's own button (from its app embed or a block elsewhere
    // on the page), and the heart copies that button's pressed state. It is only shown when that
    // button can be tied to THIS product, so a related-product card's button is never used.
    const proxy=slot.querySelector('[data-wishlist-proxy]');
    if(!proxy)return;
    const info=this.querySelector('.pp-info');
    const keys=[info?.dataset.productId,info?.dataset.productHandle].filter(Boolean);
    const mentionsProduct=el=>{
      for(let node=el,depth=0;node&&node!==document.body&&depth<5;node=node.parentElement,depth++){
        if([...node.attributes].some(a=>keys.some(k=>a.value.includes(k))))return true;
      }
      return [...el.querySelectorAll('*')].some(n=>[...n.attributes].some(a=>keys.some(k=>a.value.includes(k))));
    };
    const findSource=()=>{
      const buttons=[...document.querySelectorAll('.wl-btn')].filter(b=>!slot.contains(b));
      return buttons.find(mentionsProduct)||null;
    };
    const sync=source=>{
      const pressed=source.getAttribute('aria-pressed');
      proxy.setAttribute('aria-pressed',pressed==='true'?'true':'false');
      const label=source.getAttribute('aria-label');
      if(label)proxy.setAttribute('aria-label',label);
    };
    const bind=source=>{
      this.wishlistSource=source;
      proxy.hidden=false;
      sync(source);
      proxy.addEventListener('click',e=>{e.preventDefault();if(this.wishlistSource?.isConnected)this.wishlistSource.click();},{signal:this.abort.signal});
      this.wishlistStateObserver=new MutationObserver(()=>sync(source));
      this.wishlistStateObserver.observe(source,{attributes:true,attributeFilter:['aria-pressed','aria-label','class']});
    };
    const source=findSource();
    if(source){bind(source);return;}
    this.wishlistSourceObserver=new MutationObserver(()=>{const found=findSource();if(found){this.wishlistSourceObserver.disconnect();bind(found);}});
    this.wishlistSourceObserver.observe(document.body,{childList:true,subtree:true});
    setTimeout(()=>this.wishlistSourceObserver?.disconnect(),10000);
  }
  routeSizeChart(){
    // MP Size Chart in CSS-selector mode injects its link once, next to the Add to cart button inside
    // the product form (the app's saved selector). When the app's own block is also in this section, the
    // injected node is MOVED (never cloned, so the app's click handling stays attached) into that block,
    // so dragging the block in the theme editor is what positions the link. With no block the link stays
    // under the buttons. The app injects once and does not poll, so nothing fights this move.
    const target=this.querySelector('[data-size-chart-block]');
    const form=this.querySelector('.pp-form');
    if(!target||!form)return;
    const isTheme=node=>node.nodeType!==1||node.matches('.pp-buy,.pp-add,input,.errors');
    const route=()=>{[...form.children].forEach(node=>{if(!isTheme(node))target.appendChild(node);});};
    route();
    this.sizeChartObserver=new MutationObserver(route);
    this.sizeChartObserver.observe(form,{childList:true});
  }
  disconnectedCallback(){this.abort?.abort();this.request?.abort();clearInterval(this.wishlistTimer);this.wishlistObserver?.disconnect();this.wishlistSourceObserver?.disconnect();this.wishlistStateObserver?.disconnect();this.sizeChartObserver?.disconnect();}
  showMedia(id){
    this.querySelectorAll('.pp-image-button.is-zoomed').forEach(b=>b.classList.remove('is-zoomed'));
    this.querySelectorAll('[data-panel]').forEach(p=>{p.hidden=p.dataset.panel!==id;p.querySelectorAll('video').forEach(v=>v.pause());});
    this.querySelectorAll('[data-media]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.media===id)));
    this.querySelector('.pp-zoom-panel').hidden=true;
  }
  stepMedia(step){
    // Previous/next arrows: move to the adjacent gallery item using the thumbnail order and the existing showMedia().
    // Wraps around at either end so both arrows stay available whenever there is more than one image.
    const thumbs=[...this.querySelectorAll('[data-media]')];
    if(thumbs.length<2)return;
    const current=Math.max(0,thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));
    const next=(current+step+thumbs.length)%thumbs.length;
    this.showMedia(thumbs[next].dataset.media);
  }
  clickHandler(e){
    const arrow=e.target.closest('[data-gallery-step]');
    if(arrow){this.stepMedia(Number(arrow.dataset.galleryStep));return;}
    const thumb=e.target.closest('[data-media]');
    if(thumb)this.showMedia(thumb.dataset.media);
    const zoom=e.target.closest('[data-zoom]');
    if(zoom){
      if(matchMedia('(min-width:990px) and (pointer:fine)').matches){const panel=this.querySelector('.pp-zoom-panel');panel.hidden=!panel.hidden;panel.style.backgroundImage=`url("${zoom.dataset.zoom}")`;panel.style.backgroundPosition='50% 50%';}
      // A mouse click does nothing in hover mode, because the image is already zoomed under the pointer.
      else if(!(this.lastPointerType==='mouse'&&this.inlineHoverMode())){this.toggleInlineZoom(zoom,e);}
    }
    if(e.target.closest('[data-zoom-close]')){this.querySelector('.pp-zoom-panel').hidden=true;this.querySelector('[data-panel]:not([hidden]) [data-zoom]')?.focus();}
    if(e.target.closest('[data-size-open]'))this.querySelector('.pp-size-dialog')?.showModal();
    if(e.target.closest('[data-dialog-close]'))e.target.closest('dialog').close();
    if(e.target.closest('[data-buy-now]'))this.buyNow(e.target.closest('[data-buy-now]'));
  }
  inlineHoverMode(){
    // True for hover-capable fine pointers (mouse, trackpad) below the desktop breakpoint.
    // Desktop side-panel mode (>=990px with a fine pointer) is excluded, so desktop behaviour is unchanged.
    return matchMedia('(hover:hover) and (pointer:fine)').matches&&!matchMedia('(min-width:990px) and (pointer:fine)').matches;
  }
  hoverZoomIn(e){
    if(e.pointerType!=='mouse'||!this.inlineHoverMode())return;
    const button=e.target.closest('.pp-image-button');
    if(!button)return;
    if(!button.classList.contains('is-zoomed')){
      this.querySelectorAll('.pp-image-button.is-zoomed').forEach(b=>b.classList.remove('is-zoomed'));
      button.classList.add('is-zoomed');
    }
    this.setInlineZoomOrigin(button,e);
  }
  hoverZoomOut(e){
    if(e.pointerType!=='mouse')return;
    const button=e.target.closest('.pp-image-button');
    if(!button||!button.classList.contains('is-zoomed'))return;
    // Ignore moves between the button and its own children; reset only when the pointer leaves the image.
    if(e.relatedTarget&&button.contains(e.relatedTarget))return;
    button.classList.remove('is-zoomed');
  }
  toggleInlineZoom(button,event){
    // Touch: tap the image to zoom in place with the same magnification as desktop, tap again to return.
    // A click that ends a pan gesture is ignored so dragging a zoomed image never exits the zoom by accident.
    if(this.panned){this.panned=false;return;}
    const zoomIn=!button.classList.contains('is-zoomed');
    this.querySelectorAll('.pp-image-button.is-zoomed').forEach(b=>b.classList.remove('is-zoomed'));
    if(!zoomIn)return;
    button.classList.add('is-zoomed');
    this.setInlineZoomOrigin(button,event);
  }
  setInlineZoomOrigin(button,event){
    const box=button.getBoundingClientRect();
    if(!box.width)return;
    const clamp=v=>Math.max(0,Math.min(100,v));
    button.style.setProperty('--zx',clamp((event.clientX-box.left)/box.width*100)+'%');
    button.style.setProperty('--zy',clamp((event.clientY-box.top)/box.height*100)+'%');
  }
  async buyNow(button){
    const form=this.querySelector('.pp-form');
    const status=this.querySelector('.pp-status');
    if(!form)return;
    button.disabled=true;
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||this.dataset.error);
      window.location.assign(`${window.Shopify?.routes?.root||'/'}checkout`);
    }catch(error){status.textContent=error.message||this.dataset.error;button.disabled=false;}
  }
  async changeVariant(input){
    this.request?.abort();this.request=new AbortController();
    const values=[...this.querySelectorAll('[data-option]:checked')].map(x=>x.value);
    const url=new URL(input.dataset.productUrl||this.dataset.url,location.origin);
    url.searchParams.set('option_values',values.join(','));url.searchParams.set('section_id',this.dataset.section);
    this.querySelectorAll('.shopify-payment-button').forEach(button=>button.hidden=true);
    const addButton=this.querySelector('.pp-add');if(addButton)addButton.disabled=true;const idInput=this.querySelector('[name="id"]');if(idInput)idInput.disabled=true;
    this.querySelector('.pp-info').setAttribute('aria-busy','true');
    try{
      const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw Error('request');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=[...html.querySelectorAll('paaro-product')].find(x=>x.dataset.section===this.dataset.section);if(!next)throw Error('section');
      // Same product: update the theme's own parts in place and keep this element, the gallery, every
      // app block and the variant picker as the live nodes the page loaded with. App embeds such as
      // MP Size Chart and Wishlist Fade initialise against the DOM once, on page load; replacing the
      // whole section would throw away the link/popup/handlers they attached. A different product
      // (combined listings) is a new page's worth of content, so it is swapped in whole.
      const sameProduct=this.querySelector('.pp-info')?.dataset.productId===next.querySelector('.pp-info')?.dataset.productId;
      let current=next;
      if(sameProduct){this.applyVariant(next);current=this;}
      else{this.replaceWith(next);next.querySelector(`[data-option][value="${input.value}"]`)?.focus({preventScroll:true});}
      url.searchParams.delete('section_id');if(current.dataset.variant){url.searchParams.delete('option_values');url.searchParams.set('variant',current.dataset.variant);}
      history.replaceState({},'',url);
    }catch(error){if(error.name!=='AbortError'){this.querySelector('.pp-status').textContent=this.dataset.error;this.querySelector('.pp-info').removeAttribute('aria-busy');}}
  }
  applyVariant(next){
    // Morphs the info column from the freshly rendered section. Children of .pp-info are taken from
    // the new markup in its order (so an optional block such as Product code can appear or vanish),
    // except: app blocks are matched by block id and the live node is kept, and the variant picker
    // keeps its live node with only its selected/available state synced, as does the Buy buttons block
    // (it contains the product form the size-chart link is injected into). The gallery is not touched;
    // only the active media changes.
    ['variant','available'].forEach(key=>{if(next.dataset[key]!==undefined)this.dataset[key]=next.dataset[key];});
    const info=this.querySelector('.pp-info');
    const nextInfo=next.querySelector('.pp-info');
    if(!info||!nextInfo){this.replaceWith(next);return;}
    const liveApps=new Map([...info.querySelectorAll(':scope>[data-app-block]')].map(block=>[block.dataset.appBlock,block]));
    const liveOptions=info.querySelector(':scope>.pp-options');
    const livePurchase=info.querySelector(':scope>.pp-purchase');
    const children=[...nextInfo.children].map(fresh=>{
      if(fresh.matches('[data-app-block]')&&liveApps.has(fresh.dataset.appBlock))return liveApps.get(fresh.dataset.appBlock);
      if(fresh.matches('.pp-options')&&liveOptions){this.syncOptions(liveOptions,fresh);return liveOptions;}
      if(fresh.matches('.pp-purchase')&&livePurchase){this.syncPurchase(livePurchase,fresh);return livePurchase;}
      return fresh;
    });
    info.replaceChildren(...children);
    info.removeAttribute('aria-busy');
    const active=next.querySelector('[data-panel]:not([hidden])');
    if(active&&this.querySelector(`[data-panel="${active.dataset.panel}"]`))this.showMedia(active.dataset.panel);
    this.hydrateDescription();
    this.renderShippingEstimate();
  }
  syncPurchase(live,fresh){
    // The Buy buttons block holds the product form that MP Size Chart's CSS selector targets, so its live
    // node (and whatever the app injected into it) is kept; only button state and the variant id change.
    ['.pp-buy','.pp-add','[name="id"]'].forEach(selector=>{
      const a=live.querySelector(selector),b=fresh.querySelector(selector);
      if(!a||!b)return;
      a.disabled=b.disabled;
      if(a.tagName==='INPUT')a.value=b.value;else a.textContent=b.textContent;
    });
  }
  syncOptions(live,fresh){
    // Same product, so the option/value structure is identical; only the state differs.
    const freshInputs=new Map([...fresh.querySelectorAll('[data-option]')].map(input=>[`${input.name}=${input.value}`,input]));
    live.querySelectorAll('[data-option]').forEach(input=>{
      const source=freshInputs.get(`${input.name}=${input.value}`);
      if(!source)return;
      input.checked=source.checked;
      if(source.dataset.productUrl!==undefined)input.dataset.productUrl=source.dataset.productUrl;
      const choice=input.closest('.pp-choice'),sourceChoice=source.closest('.pp-choice');
      if(choice&&sourceChoice)choice.classList.toggle('pp-unavailable',sourceChoice.classList.contains('pp-unavailable'));
    });
    const freshLegends=[...fresh.querySelectorAll('legend')];
    live.querySelectorAll('legend').forEach((legend,index)=>{
      const liveValue=legend.querySelector(':scope>span'),freshValue=freshLegends[index]?.querySelector(':scope>span');
      if(liveValue&&freshValue)liveValue.textContent=freshValue.textContent;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
